import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.navigation.NavDestination.Companion.hasRoute
import androidx.navigation.NavHostController
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import androidx.navigation.compose.currentBackStackEntryAsState
import androidx.navigation.toRoute
import kotlinx.serialization.Serializable
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf

@Serializable
object Home

@Serializable
data class Game(val gameCode: String, val playerName: String)

@Composable
fun BankoNavHost(
    modifier: Modifier = Modifier,
    navController: NavHostController,
    onShowSnackbar: (String) -> Unit = {}
) {
    // Home counts as showing only once it is the current entry, not while a transition or a
    // predictive-back swipe merely draws it under a game.
    val currentEntry by navController.currentBackStackEntryAsState()
    val homeIsCurrent = currentEntry?.destination?.hasRoute<Home>() == true
    NavHost(
        modifier = modifier,
        navController = navController,
        startDestination = Home
    ) {
        // koinViewModel scopes each view model to its back-stack entry, so leaving a game clears it
        // (cancelling the game's listeners, bots and ad state). koinInject made a plain instance
        // on every visit that was never cleared.
        composable<Home> {
            val viewModel = koinViewModel<BankoStartScreenViewModel>()
            BankoStartScreen(
                bankoStartScreenViewModel = viewModel,
                isCurrentScreen = homeIsCurrent,
                onShowSnackBar = onShowSnackbar,
                navigateToGame = { gameCode, playerName ->
                    navController.navigate(Game(gameCode, playerName))
                })
        }
        composable<Game> { entry ->
            val game: Game = entry.toRoute()
            val viewModel = koinViewModel<BankoGameScreenViewModel> {
                parametersOf(game.gameCode, game.playerName)
            }
            BankoGameScreen(
                bankoGameScreenViewModel = viewModel,
                navigateBack = { navController.navigateUp() },
                onShowSnackbar = onShowSnackbar
            )
        }
    }
}
